<template>
	<div>
		<v-dialog v-model="dialog_transactionTypeList" no-click-animation persistent scrollable content-class="full-height select_field_dialog" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width><span>Select</span>&nbsp;<span>{{$parent.toolbarTitle}}</span>&nbsp;<span>Form</span>
	        			<!-- <v-spacer></v-spacer>
	        			<v-btn color="primary" small flat justify-content-to-end nomargin :ripple="false" @click="fn_newTransactionType" v-if="!hideNew">new</v-btn> -->
	        		</v-subheader>

	        		<v-text-field  solo flat placeholder="Search" v-model="searchValue"></v-text-field>
	        	</v-card-title>
	        	
		        <v-card-text full-height nopadding :class="{'no-items-list-card': !filteredItems.length}">

			        <v-list nopadding>
			        	<v-list-tile v-for="(item, index) in filteredItems" :key="index" @click="setTransactionType(item, null, true)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{item.name}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
						        <v-icon v-if="item.transactionTypeFormId == selectedTypeFormId">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>
			        	</v-list-tile>
			        </v-list>

			        <div class="display_msg" v-if="!filteredItems.length">No Items</div>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
          			<v-btn small color="blue darken-1" flat @click="clearAll" v-if="clearAllBtn">remove</v-btn>
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['transactionTypeId', 'setTransactionType', 'selectedTypeFormId', 'transactionTypeList', 'hideNew', 'clearAllBtn', 'clearAll'],
		data(){
			return{
				dialog_transactionTypeList:false,
				searchValue:''
			}
		},
		methods:{
			openDialogWeb: function () {
				this.searchValue = '';
				this.dialog_transactionTypeList = true;
			},
			closeDialogWeb: function () {
				this.dialog_transactionTypeList = false;
			},
			fn_newTransactionType: function () {
				this.$parent.backButtonPress = false;
				this.$router.push({path:"/settings/transaction/"+this.transactionTypeId+'/new', query:{tagId:this.guidWeb(), ls:1}});
			},
		},
		computed:{
			filteredItems: function () {
		        let searchText = this.searchValue.toLowerCase();

		        if(this.transactionTypeList && this.transactionTypeList.length){
		        	return this.transactionTypeList.filter(item => {
			          let name = item.name.toLowerCase();
			          return name.match(searchText);
			        })	
		        }
		        else{
		        	return [];
		        }
		        
		    }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_transaction_type_list.vue